// extracted by mini-css-extract-plugin
module.exports = {"Property":"Status_Property__1l18Q","ConsultantMessage":"Status_ConsultantMessage__lNer_"};